// extracted by mini-css-extract-plugin
export default {"contentWrapper":"TakeSessionComponent_contentWrapper__V01OG","btnWrapper":"TakeSessionComponent_btnWrapper__d9aEB"};